import HTTPClient from '../common/http-client'

export const userService = {
  resetPassword,
  updateUserInfo,
  getUserInfo,
  updateAvatar,
  updateUserNickname,
  postSendVerifyEmail,
  postConfirmVerifyCode
}

function getHttpUsers() {
  return HTTPClient.getInstance().httpUsers
}

function getHttpUsersNoToken() {
  return HTTPClient.getInstance().httpUsersNoToken
}

// RESET PASSWORD
async function resetPassword(password) {
  const requestBody = { password: password }
  const res = await getHttpUsers().post('/self/resetPass', requestBody)
  return res
}

// UPDATE USER INFORMATION
async function updateUserInfo(email, nickName, phoneNumber, sex) {
  const requestBody = { email, nickName, phoneNumber, sex }
  const res = await getHttpUsers().post('/self/update', requestBody)
  return res.data
}

// UPDATE USER NICKNAME
async function updateUserNickname(nickName) {
  const requestBody = { nickName }
  const res = await getHttpUsers().post('/self/update', requestBody)
  return res.data
}

// UPDATE AVATAR
async function updateAvatar(avatar) {
  const formData = new FormData()
  formData.append('file', avatar)
  const res = await getHttpUsers().post('/self/avatar', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
  return res.data
}

// GET USER INFO
async function getUserInfo() {
  const origin = window.location.origin
  const res = await getHttpUsers().get(`/verifyToken?origin=${origin}`)
  return res.data.data
}

// SEND VERIFY CODE
async function postSendVerifyEmail(email) {
  const res = await getHttpUsersNoToken().post('/sendVerifyCode', null, {
    params: {
      email
    }
  })
  return res.data
}
// CONFiRM VERIFY CODE
async function postConfirmVerifyCode(code, email) {
  const res = await getHttpUsersNoToken().post('/verifyCode', null, {
    params: {
      code,
      email
    }
  })
  return res.data
}



// WEBPACK FOOTER //
// ./src/_services/user.service.js